
export default

	props:
		embed: String
		aspectRatio: Number

	computed:

		# Make the rule that forces aspect ratio
		aspectStyle: ->
			return unless @aspectRatio
			paddingTop: (100 / @aspectRatio) + '%'

